<dx-data-grid #gridAllegati [dataSource]="dataSource" [showBorders]="true" [focusedRowEnabled]="false"
  [focusedRowIndex]="0" [allowColumnResizing]="true" [columnAutoWidth]="true"
  [columnResizingMode]="columnResizingMode" [showColumnLines]="true" [showRowLines]="true"
  [rowAlternationEnabled]="true" [allowColumnReordering]="true" [wordWrapEnabled]="false"
  (onToolbarPreparing)="onToolbarPreparing($event)" (onExporting)="onExporting($event)">

  <dxo-editing mode="row" [allowAdding]="false" [allowUpdating]="false" [allowDeleting]="false" [useIcons]="true">
    <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts>
  </dxo-editing>

  <dxo-paging [pageSize]="10"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [showInfo]="true" [allowedPageSizes]="[10, 20, 50, 100, 200]"></dxo-pager>
  <dxo-filter-row [visible]="false"></dxo-filter-row>
  <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
  <dxo-export [enabled]="true"></dxo-export>
  <dxo-column-chooser [enabled]="false"></dxo-column-chooser>


  <dxi-column type="buttons" [width]="60" [visible]="false">
    <dxi-button name="edit"></dxi-button>
    <dxi-button name="delete"></dxi-button>
  </dxi-column>

  <dxi-column name="scaricaFile" [allowFiltering]="false" [allowSorting]="false" cellTemplate="scaricaFile" caption=""
    width="25">
  </dxi-column>
  <dxi-column name="vediFile" [allowFiltering]="false" [allowSorting]="false" cellTemplate="vediFile" caption=""
    width="25">
  </dxi-column>
  <dxi-column name="deleteFile" [allowFiltering]="false" [allowSorting]="false" cellTemplate="deleteFile" caption=""
    width="25">
  </dxi-column>
  <dxi-column dataField="nome"></dxi-column>
  <div *dxTemplate="let d of 'scaricaFile'">
    <i class="dx-icon-download" (click)="scaricaFile(d.data)" style="cursor: pointer;" data-toggle="tooltip"
    data-placement="top" title="Scarica allegato"></i>
  </div>
  <div *dxTemplate="let d of 'vediFile'">
    @if (endsWith(d.data.nomeFile, '.jpg') || endsWith(d.data.nomeFile, '.png')) {
      <i class="dx-icon-image"
        (click)="visualizzaImmagine(d.data)" style="cursor: pointer;" data-toggle="tooltip" data-placement="top"
      title="Visualizza immagine"></i>
    }
    @if (endsWith(d.data.nomeFile, '.pdf')) {
      <i class="dx-icon-doc" (click)="visualizzaFile(d.data)"
      style="cursor: pointer;" data-toggle="tooltip" data-placement="top" title="Visualizza allegato"></i>
    }
  </div>
  <div *dxTemplate="let d of 'deleteFile'">
    <i class="dx-icon-trash" (click)="eliminaFile(d.data)" style="cursor: pointer;" data-toggle="tooltip"
    data-placement="top" title="Elimina allegato"></i>
  </div>

</dx-data-grid>

<dx-popup [width]="600" [height]="450" [showTitle]="true" title="" [dragEnabled]="false" [hideOnOutsideClick]="true"
  [(visible)]="popupImageVisible">
  <img style="max-width: 100%; max-height: 100%;" [src]="currentImage" alt="Immagine Allegato Articolo">
</dx-popup>

@if (visiblePopUpNewAllegato && idArticolo) {
  <div>
    <dx-popup [width]="400" [height]="400" [showTitle]="true" title="Nuovo allegato" [dragEnabled]="true"
      [hideOnOutsideClick]="true" [showCloseButton]="true" [(visible)]="visiblePopUpNewAllegato">
      
      <app-form-allegato
        [idRecord]="idArticolo"
        [tabellaRif]="tabRifAllegati"
        (formNewAllegatoEventEmitter)="ricaricaAllegatiEvent($event)">
      </app-form-allegato>
    </dx-popup>
  </div>
}